import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {DownloadIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    article: {
        attachments: {
            file: string;
            title: string;
            id: number;
        }[];
    };
}

export const ArticleAttachment: React.FC<IProps> = (props) => {
    return props.article.attachments.length > 0 ? (
        <div css={[articleAttachment]}>
            <Text mb="1.2rem" variant="headline_4" as="div" fontFamily="secondary">
                Załącznik do pobrania
            </Text>

            <ul css={listHolder}>
                {props.article.attachments.map(({id, title, file}) => {
                    return (
                        <li key={id} css={downloadItem}>
                            <Text as="div" variant="body_copy_2">
                                {title}
                            </Text>

                            <Button href={file} target="_blank" iconLeft={DownloadIcon} variant="filled_primary">
                                Pobierz
                            </Button>
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : null;
};

const articleAttachment = css`
    ${p(4)};
    ${borderRadius(2)};
    ${mb(2)};
    background-color: #fff;
`;

const downloadItem = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${mb(2)};
`;

const listHolder = css`
    padding: 0;
    margin: 0;
    list-style: none;
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {DownloadIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    article: {
        attachments: {
            file: string;
            title: string;
            id: number;
        }[];
    };
}

export const ArticleAttachment: React.FC<IProps> = (props) => {
    return props.article.attachments.length > 0 ? (
        <div css={[articleAttachment]}>
            <Text mb="1.2rem" variant="headline_4" as="div" fontFamily="secondary">
                Załącznik do pobrania
            </Text>

            <ul css={listHolder}>
                {props.article.attachments.map(({id, title, file}) => {
                    return (
                        <li key={id} css={downloadItem}>
                            <Text as="div" variant="body_copy_2">
                                {title}
                            </Text>

                            <Button href={file} target="_blank" iconLeft={DownloadIcon} variant="filled_primary">
                                Pobierz
                            </Button>
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : null;
};

const articleAttachment = css`
    ${p(4)};
    ${borderRadius(2)};
    ${mb(2)};
    background-color: #fff;
`;

const downloadItem = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${mb(2)};
`;

const listHolder = css`
    padding: 0;
    margin: 0;
    list-style: none;
`;
